var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRight0Xe822(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6641 10.0003C16.6641 9.54009 16.291 9.16699 15.8307 9.16699L4.16406 9.16699C3.70382 9.16699 3.33073 9.54009 3.33073 10.0003C3.33073 10.4606 3.70383 10.8337 4.16406 10.8337L15.8307 10.8337C16.291 10.8337 16.6641 10.4606 16.6641 10.0003Z",
    fill: "#001E64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5919 3.57709C10.2664 3.25165 9.73879 3.25165 9.41335 3.57709L3.58002 9.41042C3.25458 9.73586 3.25458 10.2635 3.58002 10.5889L9.41335 16.4223C9.73879 16.7477 10.2664 16.7477 10.5919 16.4223C10.9173 16.0968 10.9173 15.5692 10.5919 15.2438L5.34778 9.99967L10.5919 4.7556C10.9173 4.43016 10.9173 3.90252 10.5919 3.57709Z",
    fill: "#001E64"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight0Xe822);
export default __webpack_public_path__ + "static/media/right_0xe822.6c1bb6bd53ad807ef1822a12cf9ca553.svg";
export { ForwardRef as ReactComponent };